import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const ShoppingCartIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M16.5446 13C17.2943 13 17.9541 12.59 18.2939 11.97L21.8726 5.48C22.2425 4.82 21.7627 4 21.0029 4H6.20844L5.26879 2H2V4H3.99926L7.59792 11.59L6.24842 14.03C5.51869 15.37 6.47834 17 7.99777 17H19.9933V15H7.99777L9.09736 13H16.5446ZM7.15808 6H19.3036L16.5446 11H9.5272L7.15808 6ZM7.99777 18C6.89818 18 6.00851 18.9 6.00851 20C6.00851 21.1 6.89818 22 7.99777 22C9.09736 22 9.99703 21.1 9.99703 20C9.99703 18.9 9.09736 18 7.99777 18ZM17.9941 18C16.8945 18 16.0048 18.9 16.0048 20C16.0048 21.1 16.8945 22 17.9941 22C19.0937 22 19.9933 21.1 19.9933 20C19.9933 18.9 19.0937 18 17.9941 18Z"
            fill="#222"
          />
        </svg>
      </IconWrapper>
    )
  },
)
